import script from "./BalLoadingBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./BalLoadingBlock.vue?vue&type=script&lang=ts&setup=true"

import "./BalLoadingBlock.vue?vue&type=style&index=0&id=5631aa1e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5631aa1e"]])

export default __exports__